
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...ccDetailsSlugEN]",
      function () {
        return require("private-next-pages/[...ccDetailsSlugEN].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...ccDetailsSlugEN]"])
      });
    }
  